// extracted by mini-css-extract-plugin
module.exports =  {"source-2":"Source2-bkgH__source-2","embed":"Source2-u5kR__embed"};